import { FC, SVGProps } from 'react';

export const DashboardIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
		<path
			d="M12 21.5V3.5M12 10.5H21M5.4 3.5H18.6C19.2365 3.5 19.847 3.75286 20.2971 4.20294C20.7471 4.65303 21 5.26348 21 5.9V19.1C21 19.7365 20.7471 20.347 20.2971 20.7971C19.847 21.2471 19.2365 21.5 18.6 21.5H5.4C4.76348 21.5 4.15303 21.2471 3.70294 20.7971C3.25286 20.347 3 19.7365 3 19.1V5.9C3 5.58483 3.06208 5.27274 3.18269 4.98156C3.3033 4.69038 3.48008 4.4258 3.70294 4.20294C4.15303 3.75286 4.76348 3.5 5.4 3.5Z"
			stroke="currentColor"
			strokeWidth="1.4"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
